import React from 'react';
import { ellipsizeMiddle, IconWrapper } from '@flexo/general';
import {
  ProfileButton,
  Search,
  CommunitiesDropDown,
  MembersDropDown,
  SitesDropDown,
} from '@flexo/atoms';
import { MenuItem, Select } from '@mui/material';
import { HiveCalendar } from '@flexo/organisms';
import { HeaderWebProps } from '../types';
import styles from '../header-web.module.scss';
import { useNavigate } from 'react-router-dom';

const ENV = (import.meta as any).env;

const {
  Header__Web__Left,
  Header__Web__Right,
  Header__Web__Center,
  Logo,
  Header__Navigation,
  Header__Navigation__Icon,
} = styles;

interface BaseHeaderWebProps extends HeaderWebProps {
  isSelectOpen?: boolean;
  setSelectOpen?: (open: boolean) => void;
  triggerSelectOpen?: () => void;
}

export const BaseHeaderWeb: React.FC<BaseHeaderWebProps> = ({
  breadcrumbs,
  showCalendar = false,
  showSearch = false,
  showProfile = false,
  showDownload = false,
  selectOptions,
  currentSelectValue,
  onSelectChange,
  isSelectOpen = false,
  setSelectOpen,
  triggerSelectOpen,
}) => {

  const navigate = useNavigate();

  return (
    <>
      <div className={Header__Web__Left}>
        <div className={Logo} onClick={() => navigate(ENV.VITE_APP_FIRST_PAGE)}>
          <IconWrapper iconName={'logo'} />
        </div>

        <div className={Header__Navigation}>
          {breadcrumbs.map((breadcrumb, index) => (
            <React.Fragment key={index}>
              {breadcrumb.type === 'communities-dropdown' ? (
                <div className={styles.Header__Navigation__Breadcrumb}>
                  <CommunitiesDropDown />
                </div>
              ) : breadcrumb.type === 'members-dropdown' ? (
                <div className={styles.Header__Navigation__Breadcrumb}>
                  <MembersDropDown />
                </div>
              ) : breadcrumb.type === 'sites-dropdown' ? (
                <div className={styles.Header__Navigation__Breadcrumb}>
                  <SitesDropDown />
                </div>
              ) : breadcrumb.isClickable ? (
                <label
                  className={`${styles.clickable}`}
                  onClick={breadcrumb.onClick}
                >
                  {ellipsizeMiddle(breadcrumb?.label || '')}
                </label>
              ) : (
                <strong>{ellipsizeMiddle(breadcrumb?.label || '')}</strong>
              )}

              {index < breadcrumbs.length - 1 && (
                <span className={`${Header__Navigation__Icon}`}>
                  <IconWrapper iconName="chevron-right" />
                </span>
              )}
            </React.Fragment>
          ))}

          {selectOptions && currentSelectValue && (
            <>
              <span className={`${Header__Navigation__Icon}`}>
                <IconWrapper iconName="chevron-right" />
              </span>
              <Select
                className="site-navigation-select"
                id="site-navigation-select"
                open={isSelectOpen}
                onOpen={() => setSelectOpen?.(true)}
                onClose={() => setSelectOpen?.(false)}
                MenuProps={{
                  className: 'site-navigation-select-menu',
                }}
                value={currentSelectValue}
                IconComponent={() => (
                  <div onClick={triggerSelectOpen}>
                    <IconWrapper
                      className={'site-navigation-select-icon'}
                      iconName="chevron-down"
                    />
                  </div>
                )}
              >
                {selectOptions.map((option) => (
                  <MenuItem
                    key={option.value}
                    disabled={option.disabled}
                    onClick={option.onClick}
                    value={option.value}
                    style={{
                      color: option.value === currentSelectValue ? 'var(--hive-primary-500)' : 'inherit',
                      fontWeight: option.value === currentSelectValue ? 600 : 'normal',
                      opacity: option.value === currentSelectValue ? 1 : 'inherit',
                    }}
                  >
                    {ellipsizeMiddle(option?.label || '')}
                  </MenuItem>
                ))}
              </Select>
            </>
          )}
        </div>
      </div>

      {showCalendar && (
        <div className={Header__Web__Center}>
          <HiveCalendar />
        </div>
      )}

      <div className={Header__Web__Right}>
        {showDownload && <IconWrapper iconName={'chevron-encircled'} />}
        {showSearch && <Search />}
        {showProfile && <ProfileButton />}
      </div>
    </>
  );
};
